import { PCFSoftShadowMap } from 'three';
export const dayTheme = {
    cloudy: {
        style: {
            backgroundColor: '#3C4245',
        },
    },
    fog: {
        style: {
            backgroundColor: '#0F203B',
        },
        shadows: { enabled: true, type: PCFSoftShadowMap },
    },
    haze: {
        style: {
            backgroundColor: '#A2915E',
        },
        shadows: true,
    },
    meteors: {
        style: {
            backgroundColor: '#0F203B',
        },
    },
    'partly-cloudy': {
        style: {
            backgroundColor: '#1677b3',
        },
    },
    rain: {
        style: {
            backgroundColor: '#1677b3',
        },
    },
    snow: {
        style: {
            backgroundColor: '#1677b3',
        },
    },
    'star-rings': {
        style: {
            backgroundColor: '#0F203B',
        },
    },
    sun: {
        style: {
            backgroundColor: '#faf4e8',
        },
    },
};
export const nightTheme = Object.assign(Object.assign({}, dayTheme), { rain: Object.assign(Object.assign({}, dayTheme.rain), { style: {
            backgroundColor: '#0F203B',
        } }), cloudy: Object.assign(Object.assign({}, dayTheme.cloudy), { style: {
            backgroundColor: '#0F203B',
        } }), 'partly-cloudy': Object.assign(Object.assign({}, dayTheme['partly-cloudy']), { style: {
            backgroundColor: '#0F203B',
        } }), snow: Object.assign(Object.assign({}, dayTheme.snow), { style: {
            backgroundColor: '#0F203B',
        } }) });
